import { types } from 'mobx-state-tree'

const PagedListRequestModel = types.model('PagedListRequestModel', {
  pageNumber: types.optional(types.number, 1),
  pageSize: types.optional(types.number, 10),
})

export default PagedListRequestModel
